import { render, staticRenderFns } from "./selectpicker.vue?vue&type=template&id=050f6ba3&"
import script from "./selectpicker.vue?vue&type=script&lang=js&"
export * from "./selectpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports